import './Card.scss';
import { CardProps } from '../../Interface/PropsInterface';

const Card = ({ children, className }: CardProps) => {
  return <div className={`Card ${className}`}>{children}</div>;
};

export default Card;
